// Minimal client-side CSV export. Quotes cells containing comma/quote/newline (RFC 4180).
const escapeCell = (value: unknown): string => {
  const s = value == null ? '' : String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const toCsv = (rows: string[][]): string =>
  rows.map((row) => row.map(escapeCell).join(',')).join('\r\n');

export const downloadCsv = (filename: string, rows: string[][]): void => {
  const blob = new Blob(['﻿' + toCsv(rows)], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
